// Sayfa key ↔ URL path ↔ breadcrumb yardımcıları.
// Mevcut activePage state mantığını koruyup üzerine URL senkronizasyonu ekler.
import { pageTitle } from './pageTitles';

// Her page key bir URL segment'i. Boş veya dashboard → /
export function pageToPath(page, recordId) {
  if (!page || page === 'dashboard') return '/';
  return '/' + page + (recordId ? '/' + recordId : '');
}

export function pathToPage(pathname) {
  if (!pathname || pathname === '/') return { page: 'dashboard', recordId: null };
  const parts = pathname.replace(/^\/+/, '').split('/');
  const page = parts[0] || 'dashboard';
  const recordId = parts[1] || null;
  return { page, recordId };
}

// Breadcrumb parent eşlemesi — alt sayfa → üst grup
// Grup key'leri MainLayout'taki "açılır parent" key'leridir.
const PARENT_OF = {
  // Cari Hesaplar grubu
  'accounts':          'cariislemleri',
  'prospect-accounts': 'cariislemleri',
  'crm-pipeline':      'cariislemleri',
  'lead-form-embed':   'cariislemleri',
  'projects':          'cariislemleri',
  'ecom-orders':       'cariislemleri',
  'ecom-catalog-embed':'cariislemleri',
  'cari-tahsilat':     'cariislemleri',
  'cari-tediye':       'cariislemleri',
  'cari-vouchers':     'cariislemleri',
  'cari-acilis':       'cariislemleri',
  'cari-borc':         'cariislemleri',
  'cari-alacak':       'cariislemleri',
  'cari-virman':       'cariislemleri',

  // Satış Modülü
  'quotes-outgoing':         'salesModule',
  'orders-incoming':         'salesModule',
  'waybills-sales':          'salesModule',
  'waybills-sales-returns':  'salesModule',
  'sales':                   'salesModule',
  'sales-returns':           'salesModule',

  // Alış Modülü
  'quotes-incoming':         'purchaseModule',
  'orders-outgoing':         'purchaseModule',
  'waybills-purchase':       'purchaseModule',
  'waybills-purchase-returns': 'purchaseModule',
  'purchases':               'purchaseModule',
  'purchases-returns':       'purchaseModule',
  'rfq':                     'purchaseModule',
  'reorder-suggestions':     'purchaseModule',
  'babs-report':             'purchaseModule',

  // Perakende
  'retail-hub':       'retailModule',
  'retail-sales':     'retailModule',
  'pos':              'retailModule',

  // Banka
  'bankaccounts':     'bankislemleri',
  'bank-pos':         'bankislemleri',
  'bank-pos-slips':   'bankislemleri',
  'bank-acilis':      'bankislemleri',
  'bank-borc':        'bankislemleri',
  'bank-alacak':      'bankislemleri',
  'bank-virman':      'bankislemleri',
  'expense-cards':    'bankislemleri',

  // Kasa
  'cashregisters':    'kasaislemleri',
  'cash-acilis':      'kasaislemleri',
  'cash-virman':      'kasaislemleri',
  'cashdef':          'kasaislemleri',
  'expense-vouchers': 'kasaislemleri',
  'expense-categories':'kasaislemleri',

  // Çek-Senet
  'cek-portfoy':   'cekislemleri',
  'cek-verilen':   'cekislemleri',
  'senet-portfoy': 'cekislemleri',
  'senet-verilen': 'cekislemleri',

  // Muhasebe
  'acc-chart':     'accounting',
  'acc-mappings':  'accounting',

  // e-Belge
  'edocument-settings':        'ebelge',
  'ebelge-outgoing-invoices':  'ebelge',
  'ebelge-outgoing-waybills':  'ebelge',
  'ebelge-incoming-invoices':  'ebelge',
  'ebelge-incoming-waybills':  'ebelge',

  // Stok İşlemleri
  'stocks':            'stokislemleri',
  'stockseries':       'stokislemleri',
  'colorsizewizard':   'stokislemleri',
  'warehouses':        'stokislemleri',
  'branches':          'programtanimlari',
  'campaigns':         'programtanimlari',
  'balance-check':     'programtanimlari',
  'warehouse-transfers':'stokislemleri',
  'stock-counts':      'stokislemleri',
  'stock-op-vouchers': 'stokislemleri',

  // Raporlar
  'reports-stocks':    'reportsModule',
  'stock-list-report': 'reportsModule',
  'stock-labels':      'reportsModule',
  'label-templates':   'reportsModule',
  'label-designer':    'reportsModule',
  'report-designer':   'reportsModule',
  'reports-accounts':  'reportsModule',

  // Personel
  'personnel':         'personelislemleri',
  'plasiyerroutes':    'personelislemleri',
  'plasiyerdaily':     'personelislemleri',
  'commissions':       'personelislemleri',
  'personnel-alacak':  'personelislemleri',
  'personnel-borc':    'personelislemleri',

  // Onay Hiyerarşisi
  'pending-approvals': 'approvalsModule',
  'approved-documents':'approvalsModule',

  // Program Tanımları
  'fiscalperiods':     'programtanimlari',
  'users':             'programtanimlari',
  'roles':             'programtanimlari',
  'pricedefinitions':  'programtanimlari',
  'platformkargo':     'programtanimlari',
  'department-modules':'programtanimlari',
  'custom-fields':     'programtanimlari',
  'lost-reasons':      'programtanimlari',
  'sales-targets':     'programtanimlari',
  'settings':          'programtanimlari',
  'auditlog':          'programtanimlari',
  'print-templates':   'programtanimlari',
  'locations':         'programtanimlari',

  // Vendor
  'vendor-companies':   'vendor',
  'vendor-plans':       'vendor',
  'vendor-messages':    'vendor',
  'vendor-team':        'vendor',
  'vendor-payment-methods':'vendor',
  'vendor-settings':    'vendor',
  'vendor-leads':       'vendor',
  'vendor-tickets':     'vendor',
  'vendor-reports':     'vendor',
  'vendor-customer-detail':'vendor',

  // Eklentiler
  'pergola-calculator': 'eklentiler',
  'pergola-templates':  'eklentiler',
};

const PARENT_LABELS = {
  cariislemleri:     'Cari İşlemler',
  salesModule:       'Satış',
  purchaseModule:    'Alış',
  retailModule:      'Perakende',
  bankislemleri:     'Banka İşlemleri',
  kasaislemleri:     'Kasa İşlemleri',
  cekislemleri:      'Çek-Senet İşlemleri',
  accounting:        'Muhasebe',
  ebelge:            'e-Belge',
  stokislemleri:     'Stok İşlemleri',
  reportsModule:     'Raporlar',
  personelislemleri: 'Personel İşlemleri',
  approvalsModule:   'Belge Onayları',
  programtanimlari:  'Program Tanımları',
  vendor:            'Vendor Panel',
  eklentiler:        'Eklentiler',
};

export function getBreadcrumb(page) {
  if (!page || page === 'dashboard') return [{ key: 'dashboard', label: 'Ana Sayfa' }];
  const crumbs = [{ key: 'dashboard', label: 'Ana Sayfa' }];
  const parentKey = PARENT_OF[page];
  if (parentKey && PARENT_LABELS[parentKey]) {
    crumbs.push({ key: parentKey, label: PARENT_LABELS[parentKey], isGroup: true });
  }
  crumbs.push({ key: page, label: pageTitle(page) || page, current: true });
  return crumbs;
}
